import { HelpOutline } from '@mui/icons-material';
import { IconButton, Popover } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';

import { helpButtonSx, popoverSx } from './styles';

import s from './InputWrapper.module.scss';

type Props = {
  label: string;
  hint?: string;
  children: ReactNode;
};

export const InputWrapper = ({ label, hint, children }: Props) => {
  const [helpAnchorEl, setHelpAnchorEl] = useState<HTMLElement | null>(null);
  const [helpTimeout, setHelpTimeout] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (helpTimeout) {
        clearTimeout(helpTimeout);
      }
    };
  }, [helpTimeout]);

  const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    if (helpTimeout) {
      clearTimeout(helpTimeout);
      setHelpTimeout(null);
    }

    setHelpAnchorEl(e.currentTarget);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setHelpAnchorEl(null);
    }, 200);
    setHelpTimeout(timeout);
  };

  return (
    <div className={s.wrapper}>
      <div className={s.label_container}>
        <p>{label}</p>
        {hint && (
          <>
            <IconButton
              size="small"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              className={s.help_button}
              sx={helpButtonSx}
            >
              <HelpOutline sx={{ fontSize: '18px' }} />
            </IconButton>
            <Popover
              open={!!helpAnchorEl}
              anchorEl={helpAnchorEl}
              onClose={() => setHelpAnchorEl(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              disableRestoreFocus
              onMouseEnter={() => {
                if (helpTimeout) {
                  clearTimeout(helpTimeout);
                  setHelpTimeout(null);
                }
              }}
              onMouseLeave={handleMouseLeave}
              sx={popoverSx}
            >
              <div>{hint}</div>
            </Popover>
          </>
        )}
      </div>
      {children}
    </div>
  );
};
